import { z } from 'zod';
import { DepartmentSchema } from '../../entities/department/department.schema';
/**
 * Show Department Request Schema
 * GET /api/v2/departments/:id
 */ export const ShowDepartmentRequestSchema = z.object({});
/**
 * Show Department Response Schema
 * GET /api/v2/departments/:id
 */ export const ShowDepartmentResponseSchema = z.object({
    data: DepartmentSchema
});

//# sourceMappingURL=show-department.schema.js.map